
<template>
<div>
  <div class="b-service" v-if="isSingle">
    <span class="bs-tell1" @click="leaveCallClick(estate[0],estate[1],estate[2],estate[3])"><a href="javascript:void(0);">致电售楼处</a></span>
    <span class="bs-getprice" @click="$emit('clickButton')">获取优惠报价</span>
  </div>
  <div class="b-service" :class="hasOnline?'edp':''" v-if="service">
    <span v-if="hasOnline" class="bs-online" @click="isService=true"><i class="m-icon"></i>在线咨询</span>
    <span class="bs-time" @click="leaveClick(8,estate[1],estate[2],estate[3])"><i class="m-icon"></i>预约看房</span>
    <span class="bs-tell" @click="leaveCallClick(estate[0],estate[1],estate[2],estate[3])"><i class="m-icon"></i>免费通话</span>
    <!-- <span class="bs-tell" @click="callClick"><i class="m-icon"></i>免费通话</span> -->
  </div>
  <div class="b-service" v-if="isKuaishou">
    <span class="bs-ks" @click="leaveCallClick(estate[0],estate[1],estate[2],estate[3],estate[4])">咨询线上售楼处</span>
  </div>
  <div class="leavewrap" :class="leaveIndex==40?'better':''" v-if="show" @click.self="show=false;isOK=false;isError=false;number='';isCheck=false">
    <div class="leavebox" v-if="!isOK">
      <p class="title">{{leaveTelItems[leaveIndex].title}}</p>
      <p class="stitle" v-if="leaveIndex==40">已有<span>{{fsnumber}}</span>人预约看房</p>
      <p class="stitle">{{leaveTelItems[leaveIndex].stitle}}</p>
      <p class="telinput"><input ref="inputTel" type="tel" placeholder="请输入手机号码" v-model="number"></p>
      <p class="telinput" v-if="codeInputShow==1&&pathType">
        <input ref="inputTel" type="tel" placeholder="请输入验证码" v-model="validCode">
        <span class="code wait" v-show="!codeShow">{{count}}s</span>
        <span class="code" v-show="codeShow" @click="getCode()">获取验证码</span>
      </p>
      <p class="error" v-if="isError">{{errorMsg}}</p>
      <p class="okbtn" @click="okClick()">立即提交</p>
      <p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
      <a @click="showXY=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
			<a @click="showXY=true;" v-if="$store.state.domainIndex==2">《素旭用户协议》</a>
      (点击可取消)</p>
    </div>
    <div class="leavebox" v-if="isOK">
      <p class="success"><i class="m-icon"></i>预留电话成功</p>
      <p class="stitle">我们将严格保护您的隐私并尽快与您联系！</p>
      <p class="okbtn" @click="show=false;isOK=false;">确定</p>
    </div>
  </div>
  <div class="leavewrap" v-if="isFind && isOK" @click.self="$emit('setIsFind', false);isOK=false;show=false;isCheck=false">
    <div class="leavebox">
      <p class="success"><i class="m-icon"></i>提交成功</p>
      <p class="stitle">已收到您的需求，我们会尽快为您找到合适的房子。</p>
      <p class="okbtn" @click="$emit('setIsFind', false);isOK=false;show=false;">确定</p>
    </div>
  </div>
  <div class="leavewrap" v-if="isRecom" @click.self="isRecom=false;isOK=false;isError=false;number='';show=false;">
    <div class="leavebox" v-if="!isOK">
      <p class="title">获取最新报价及优惠折扣</p>
      <div class="recomInput" v-if="selectEstate=='2'"><span>楼盘名称</span>
        <el-select v-model="sevalue" placeholder="请选择楼盘" @change="changeSelect">
          <el-option v-for="(item,index) in estateItem" :key="index" :label="item.estateName" :value="item.estateId"></el-option>
        </el-select>
      </div>
      <div class="recomInput"><span>手机号</span><input ref="inputTel" type="tel" placeholder="请输入手机号" v-model="number"></div>

      <!-- <div v-show="codeInputShow==1?true:false">
        <div class="recomInput">
          <span>验证码</span>
          <input ref="inputTel" type="tel" placeholder="请输入验证码" v-model="validCode" />
          <p class="code wait" v-show="!codeShow">{{count}}s</p>
          <p class="code" v-show="codeShow" @click="getCode()">获取验证码</p>
        </div>
      </div> -->

      <p class="error" v-if="isError">{{errorMsg}}</p>
      <p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
      <a @click="showXY=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
			<a @click="showXY=true;" v-if="$store.state.domainIndex==2">《素旭用户协议》</a>
      (点击可取消)</p>
      <p class="okbtn" @click="okClick()">立即获取</p>

    </div>
    <div class="leavebox" v-if="isOK">
      <p class="success"><i class="m-icon"></i>提交成功</p>
      <p class="stitle">已收到您的需求，稍后我们会发送该房源最新报价及优惠折扣信息。</p>
      <p class="okbtn" @click="isRecom=false;isOK=false;show=false">确定</p>
    </div>
  </div>

  <div class="codewrap" v-if="isCode" @click.self="$emit('setIsCode', false);">
    <div class="codebox">
      <span class="colseicon"></span>
      <p class="ctitle">手机验证<small>短信验证码已发送至{{number.replace(/^(\d{3})\d{4}(\d+)/,"$1****$2")}}</small></p>
      <div class="codeinput">
        <input type="number" class="input" placeholder="请输入短信验证码" v-model="validCode" />
        <span class="codebtn" v-show="codeShow" @click="getCode(number)">获取验证码</span>
        <span class="codebtn wait" v-show="!codeShow">重新获取({{count}}s)</span>
      </div>
      <p class="error" v-if="isError">{{errorMsg}}</p>
      <p class="codesubmit" @click="chekSmsCode(1)">确定</p>
    </div>
  </div>
  <div class="servicewrap" v-if="isService" @click.self="isService=false;isCheck=false">
    <div class="whitewrap">
      <p class="svtitle">欢迎咨询客服<span>已有<b>{{second}}</b>人咨询</span><small>您好，客服现在正忙，若有问题可先留言、留电，客服看到信息后将火速与您取得联系。</small></p>
      <div class="tellbox"><input type="text" class="tel-input" placeholder="请输入您的姓名" v-model="username" ref="inputName"></div>
      <div class="tellbox"><input type="tel" class="tel-input" placeholder="请输入手机号码" v-model="number" ref="inputTel"></div>
      <div class="tellbox" v-if="codeInputShow==1&&pathType">
        <input clean type="number" placeholder="请输入验证码" v-model="validCode">
        <a class="codebtn" v-show="codeShow" @click="getCode(number)">获取验证码</a>
        <a class="codebtn wait" v-show="!codeShow">重新获取(<i>{{count}}</i>s)</a>
      </div>
      <p class="error" v-if="isError">{{errorMsg}}</p>
      <a class="okbtn" @click="serOkClick()">提交</a>
      <p class="xy"><span class="checklabel" @click="changeCheck()"><i class="checkbox" :class="isCheck==true?'yes':''"></i>我已阅读</span>
      <a @click="showXY=true;" v-if="$store.state.domainIndex==1">《优道用户协议》</a>
			<a @click="showXY=true;" v-if="$store.state.domainIndex==2">《素旭用户协议》</a>
      (点击可取消)</p>
    </div>
  </div>

    <div v-if="$store.state.domainIndex==1" class="xybox" v-show="showXY||isShowXy" @click="showXY=false;$emit('setIsShowXy',false);">
      <span class="closexy">关闭</span>
      <h3>《优道个人信息保护指引》</h3>
      <p>尊敬的客户，优道平台（“我们”或“优道”）非常重视您的个人信息和隐私权保护。本《个人信息保护指引》（“本指引”）将向您说明， 我们如何收集、使用、存储和保护您的个人信息。</p><p>
      <b>一、我们收集和使用您的个人信息</b><br/>
      当您查看感兴趣的房源楼盘页面时，您可以通过点击拨打电话的按钮直接致电我们为你匹配的专业的房地产经纪人，或通过主动填写您的联系方式等待专业的房地产经纪人员与您联系。在您使用上述两种方式期待获得经纪服务时，我们将收集您的手机号码以便匹配专业经纪人为您服务。</p>
      <p><b>二、关于共享您的个人信息</b><br/>
      除以下情况，我们不会与优道加盟商或代运营合作商户以外的任何公司、组织和个人共享您的个人信息：事先获得您明确的同意或授权；为履行法律法规明确要求我们履行的义务；与国家安全、国防安全直接相关的；与公共安全、公共卫生、重大公共利益直接相关的；与犯罪侦查、起诉、审判和判决执行等直接相关的；出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；自行向社会公众公开的个人信息；从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p><p>
      <b>三、我们存储和保护您的个人信息</b><br/>
      您的个人信息将会被存储于中华人民共和国境内。我们将采取安全技术和管理措施来防止您的个人信息遭到未经授权访问使用、公开披露、使用、修改、损坏或丢失。
      </p><p>
      <b>四、如何删除您的个人信息</b><br/>
      如您需要查询、撤回同意、删除您的个人信息，则您可以通过发送邮件至liushengyang@milike.com方式联系我们，我们会在15个日内予以回复。
      </p>
    </div>

    <div v-if="$store.state.domainIndex==2" class="xybox" v-show="showXY||isShowXy" @click="showXY=false;$emit('setIsShowXy',false);">
      <span class="closexy">关闭</span>
      <h3>《素旭个人信息保护指引》</h3>
      <p>尊敬的客户，素旭平台（“我们”或“素旭”）非常重视您的个人信息和隐私权保护。本《个人信息保护指引》（“本指引”）将向您说明， 我们如何收集、使用、存储和保护您的个人信息。</p><p>
      <b>一、我们收集和使用您的个人信息</b><br/>
      当您查看感兴趣的房源楼盘页面时，您可以通过点击拨打电话的按钮直接致电我们为你匹配的专业的房地产经纪人，或通过主动填写您的联系方式等待专业的房地产经纪人员与您联系。在您使用上述两种方式期待获得经纪服务时，我们将收集您的手机号码以便匹配专业经纪人为您服务。</p>
      <p><b>二、关于共享您的个人信息</b><br/>
      除以下情况，我们不会与素旭加盟商或代运营合作商户以外的任何公司、组织和个人共享您的个人信息：事先获得您明确的同意或授权；为履行法律法规明确要求我们履行的义务；与国家安全、国防安全直接相关的；与公共安全、公共卫生、重大公共利益直接相关的；与犯罪侦查、起诉、审判和判决执行等直接相关的；出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；自行向社会公众公开的个人信息；从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p><p>
      <b>三、我们存储和保护您的个人信息</b><br/>
      您的个人信息将会被存储于中华人民共和国境内。我们将采取安全技术和管理措施来防止您的个人信息遭到未经授权访问使用、公开披露、使用、修改、损坏或丢失。
      </p><p>
      <b>四、如何删除您的个人信息</b><br/>
      如您需要查询、撤回同意、删除您的个人信息，则您可以通过发送邮件至liushengyang@milike.com方式联系我们，我们会在15个日内予以回复。
      </p>
    </div>

  <div class="svwrap" v-if="showSV" @click.self="showSV=false;">
    <slide ref="slideblock" @success="onSuccess" @again="onAgain" @fulfilled="onFulfilled" @fail="onFail" @refresh="onRefresh" :accuracy="accuracy" :slider-text="svtext" :imgs="imgs"></slide>
  </div>
</div>
</template>

<script>
import img1 from '../../assets/images/slide/1.jpg';
import img2 from '../../assets/images/slide/2.jpg';
import img3 from '../../assets/images/slide/3.jpg';
import img4 from '../../assets/images/slide/4.jpg';
import img5 from '../../assets/images/slide/5.jpg';
import img6 from '../../assets/images/slide/6.jpg';
import img7 from '../../assets/images/slide/7.jpg';
import img8 from '../../assets/images/slide/8.jpg';
import img9 from '../../assets/images/slide/9.jpg';
import img10 from '../../assets/images/slide/10.jpg';
export default {
  name: 'LeaveTel',
  components:{
    Slide: resolve => require(['@/components/public/SlideVerify'],resolve),
  },
  props:{
    service:Boolean,
    estate:Array,
    isFind:Boolean,
    estateItem:Array,
    isXprtFlag:Boolean,
    isSingle:Boolean,
    isKuaishou:Boolean,
    isCode:Boolean,
    selectEstate:[String,Number],
    hasOnline:Boolean,
    isShowXy:Boolean,
  },
  data(){
    return{
      leaveTelItems:[
        {id:0,title:'售楼处温馨提示：',stitle:'订阅楼盘优惠，不用砍价，也能享受如特价房源一般的优惠！',inType:'lpxqy_mfzxyh'},
        {id:1,title:'获取楼盘底价信息',stitle:'同一户型价差这么大？！订阅楼盘底价消息，掌握房源真实价格，避免信息差所造成的决策失误！',inType:'lpxqy_bjkpyhtzw'},
        {id:2,title:'售楼处温馨提示：',stitle:'找不到楼盘位置，担心日晒雨淋……一键预约专车，让专车司机为您看房保驾护航，还有专属顾问一对一为您买房支招。',inType:'lpxqy_yyzc'},
        {id:3,title:'了解剩余房源情况',stitle:'担心自己喜爱的户型已卖完，不确定高楼层还有没有房……订阅剩余房源情况，快速查看每一套具体的房源在售和价格情况。',inType:'lpxqy_ljsyfyqk'},
        {id:4,title:'区位资料全面获取',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_qwzlqmhq'},
        {id:5,title:'获取实时动态消息',stitle:'怕错过开盘时间、限时折扣、特价房源消息？有新动态咨询师将第一时间通知您。',inType:'lpxqy_xdttzw'},
        {id:6,title:'查看完整分析报告',stitle:'楼盘有哪些优劣势？性价比如何？还有什么类似楼盘推荐…更多问题，买房咨询师帮您答疑解惑。',inType:'lpxqy_fdzczxfw'},
        {id:7,title:'了解区域房价走势',stitle:'房价如何变化？什么时候买房最合适？专业咨询师免费为您解答疑问！',inType:'lpxqy_hqxqdptxx'},
        {id:8,title:'售楼处温馨提示：',stitle:'为确保优质看房体验，确保一对一专人讲解，请提前预约看房，告知看房时间。',inType:'lpxqy_yykf'},
        {id:9,title:'优先获知本地段未来规划',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_qyghqxtz'},
        {id:10,title:'咨询职业顾问',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_zxzygw'},
        {id:11,title:'订阅动态',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_dydt'},
        {id:12,title:'购房须知',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_gfxz'},
        {id:13,title:'获取楼盘底价信息',stitle:'同一户型价差这么大？！订阅楼盘底价消息，掌握房源真实价格，避免信息差所造成的决策失误！',inType:'lpxqy_bjkpyhtzw'},
        {id:14,title:'免费通话',stitle:'',inType:'hotline'},
        {id:15,title:'售楼处温馨提示：',stitle:'为确保优质看房体验，确保一对一专人讲解，请提前预约看房，告知看房时间。',inType:'hxxqy_yykf'},
        {id:16,title:'获取楼盘底价信息',stitle:'同一户型价差这么大？！订阅楼盘底价消息，掌握房源真实价格，避免信息差所造成的决策失误！',inType:'hxxqy_bjkpyhtzw'},
        {id:17,title:'房贷政策咨询服务',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'hxxqy_fdzczxfw'},
        {id:18,title:'户型细节一手掌握',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'hxxqy_hxxjyszw'},
        {id:19,title:'了解剩余房源情况',stitle:'担心自己喜爱的户型已卖完，不确定高楼层还有没有房……订阅剩余房源情况，快速查看每一套具体的房源在售和价格情况。',inType:'hxxqy_ljsyfyqk'},
        {id:20,title:'售楼处温馨提示：',stitle:'为确保优质看房体验，确保一对一专人讲解，请提前预约看房，告知看房时间。',inType:'xcxqy_yykf'},
        {id:21,title:'售楼处温馨提示：',stitle:'为确保优质看房体验，确保一对一专人讲解，请提前预约看房，告知看房时间。',inType:'dtxqy_yykf'},
        {id:22,title:'帮我找房',stitle:'',inType:'help_me_findhouse'},
        {id:23,title:'立即订阅房源动态',stitle:'',inType:'rmzthp_dyfydt'},
        {id:24,title:'获取最新报价和优惠',stitle:'',inType:'rmzthp_hqpjyh'},
        {id:25,title:'立即匹配合适房源',stitle:'',inType:'rmzthp_ljpphsfy'},
        {id:26,title:'获取楼盘深度评测',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_qwlpsdpc'},
        {id:27,title:'开启购房之旅',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'kfs_yykf_kqgfzl'},
        {id:28,title:'开启购房之旅',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'kfs_ppjs_kqgfzl'},
        {id:29,title:'变价提醒',stitle:'价格变动太快？订阅楼盘价格通知，降价信息及时知晓。',inType:'lpxqy_bjtzw'},
        {id:30,title:'开盘提醒',stitle:'输入手机号，及时接收开盘信息；再也不会错过楼盘开盘，楼市新盘抢先知。',inType:'lpxqy_kptx'},
        {id:31,title:'在线咨询',stitle:'我们将为您保密个人信息！请填写您接收订阅的手机号码。',inType:'lpxqy_zxzx'},
        {id:32,title:'了解优惠',stitle:'买房怕买贵了？马上订阅，楼盘报价、成交价实时推送，让您心里有底，买房不慌！',inType:'lpxqy_ljyh'},
        {id:33,title:'获取底价',stitle:'怕错过特价房、不清楚楼盘优惠？马上订阅，楼盘折扣、优惠、特价房消息实时推送，抢先抓住抄底时机。',inType:'lpxqy_hqdj'},
        {id:34,title:'了解更多成交价',stitle:'买房怕买贵了？马上订阅，楼盘报价、成交价实时推送，让您心里有底，买房不慌！',inType:'lpxqy_ljgdcjj'},
        {id:35,title:'了解更多余房',stitle:'看房之前查一查房源在售情况，即时掌握房源价格、楼层变化情况，选定自己的专属房源。',inType:'lpxqy_ljgdyf'},
        {id:36,title:'订阅专属置业报告',stitle:'想知道楼盘周边有啥配套和规划、环境如何、区域有没有前景？订阅专属置业报告，楼盘综合情况全掌握。',inType:'lpxqy_dyzszybg'},
        {id:37,title:'了解附近房价和租房',stitle:'担心楼盘房价太高、房租太低？马上订阅，附近房价、房租信息实时推送，买房、卖房都放心。',inType:'lpxqy_ljfjfjhzf'},
        {id:38,title:'免费领取楼盘优惠',stitle:'快速获取楼盘一手优惠，让买房省心、少花钱！楼盘优惠、折扣、一口价房源信息同步告知。',inType:'lpxqy_mfzxyh'},
        {id:39,title:'了解全部备案价格',stitle:'买不买房，先看看房源备案价。真实价格一目了然，买房决策不再困难。',inType:'lpxqy_ljqbbajg'},
        {id:40,title:'楼盘地址发送',stitle:'一键“楼盘位置发送”，帮您快速找到售楼处！',inType:'lpxqy_lpdzfs'},
      ],
      leaveIndex:0,
      params:{
        phone:null,
        type:null,
        estateId:null,
        estateName:null,
        column:null,
        projectPkId:null,
        channel:null,
        bdUrl:null,
        qrId:null,
        remark:null,
        customerName:null
      },
      show:false,
      isRecom:false,
      sevalue:'',
      number:'',
      validCode:'',
      isOK:false,
      isError:false,
      errorMsg:'请输入正确手机号码！',
      codeShow:true,
      count: '',
      timer: null,
      codeInputShow:2,
      pathType:false,
      second:888,
      username:'',
      isService:false,
      isCheck:false,
      showXY:false,

      showSV:false,
      svtext:'',
      imgs: [img1,img2,img3,img4,img5,img6,img7,img8,img9,img10],
      accuracy: 5, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      calldata:{
        phone:'',
        eid:'',
        ename:'',
        column:'',
        proid:'',
        index:'',
        remark:''
      },
      callImgCode: "0",
      imgCodeSuccess: false,
      fsnumber:10
    }
  },
  watch:{
    isFind:function(a,b){
      this.queryData(a);
    }
  },
  mounted(){
    var _this = this;
      //查询验证码开关是否打开
    if(this.$route.path.indexOf('estateDetail')>-1&&this.estate){
      //如果是楼盘详情界面，查询配置开关,主页与新盘热推页查询自己的开关配置
      _this.pathType = true;
      this.$http.get('/api/index/getMsgSwitch?type=1&id=' + _this.estate[1]).then((response)=>{
        if(response.data.result){
          this.codeInputShow = response.data.result;
        }
      }).catch((response)=>{
        console.log(response)
      })
    }
    if(this.hasOnline==true){
      var sec=new Date().getSeconds();
      if(sec<10){
        sec ="1"+sec;
      }
      this.second='10'+sec;
    }
    if (this.estate) {
      this.setFsNumber(this.estate[1]);
    }
  },
  methods:{
    setFsNumber(id){
      var num = Number(id.substring(id.length-2));
      if (num<10) {
        num += 10;
      }
      this.fsnumber = num
    },
    onSuccess (times) {
      var self=this;
      self.svtext='验证成功！';
      var time;
      clearTimeout(time);
      self.imgCodeSuccess = true;
      time=setTimeout(function(){
        self.lastLeaveCallClick();
        self.showSV=false;
      },1000)

    },
    onFail () {
      this.svtext='验证失败，请重试！';
    },
    onRefresh () {
      // console.log('点击了刷新小图标');
    },
    onFulfilled () {
      // console.log('刷新成功啦！');
    },
    onAgain () {
      // console.log('检测到非人为操作！');
      // 刷新
      this.handleClick();
    },
    handleClick () {
      this.$refs.slideblock.reset();
    },

    changeCheck(){
      this.isCheck=!this.isCheck;
    },
    queryData(param){},
    chekSmsCode:function(index){

      if(this.validCode==null || this.validCode==''){
        this.isError =true;
        this.errorMsg = '请输入验证码';
        return false;
      }

      this.isError =false;
      this.errorMsg = '';

      //校验验证码
      this.$http.get('/api/user/checkSmsCode?mobile='+this.number+'&smsCode='+this.validCode).then((response)=>{

        if(!response.data.result){
          this.isError = true;
          this.errorMsg = response.data.msg;
          return false;
        }

        this.isError = false;
        this.errorMsg = '请输入正确手机号码！';
        this.validCode = '';
        this.sendFromInLine();
        if(index==1){
          this.$emit('setIsFind', true);
        }
        if(index==2){
          this.isService=false;
        }
      }).catch((response)=>{
        this.isError = true;
        this.errorMsg = '验证码错误';
        return false;
      })
    },
    okClick:function(){
      if(this.number==null||this.number==""){
        this.$refs.inputTel.focus();
      }
      if(!this.checkPhone(this.number)){
        this.errorMsg = '请输入正确手机号码！';
        return false;
      }
      this.params.phone = this.number;

      if(this.isCheck!=true){
        this.isError= true;
        this.errorMsg = '请阅读并勾选用户协议!';
        return false;
      }
      //判断是否需要验证码校验,并且只有新盘热推界面过来的才需要校验
      if(this.codeInputShow==1 && this.isXprtFlag){
        this.getCode(this.number)
      }else if(this.codeInputShow==1 && this.pathType){//判断是否需要验证码校验,并且只有楼盘详情界面过来的才需要校验
        this.chekSmsCode();
      } else {
        //发送请求表单预留
        this.sendFromInLine();
      }
    },

    getCode: function(phone){
      console.log(phone)
      if(phone){
        this.number=phone
      }
      //校验手机号码
      if(!this.checkPhone(this.number)){
        return false;
      }

      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.codeShow = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.codeShow = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
      }

      //获取验证码
      this.$http.get('/api/user/getSmscode?mobile='+this.number).then((response)=>{
        if(response.data.result && !response.data.result.resultCode && response.data.result.msg!=null){
          if(phone){
            this.$emit('setError', response.data.result.msg);
            this.$emit('setIsCode',false);
          }else{
            this.isError = true;
            this.errorMsg =  response.data.result.msg;
          }
        }else{
          if(phone){
            this.count=59;
            this.$emit('setIsCode',true);
          }else{
            this.isError = false;
            this.errorMsg = '';
          }
        }
      }).catch((response)=>{
        console.log(response)
      })
    },
    checkPhone(phone){
      if(!(/^1[3456789]\d{9}$/.test(phone))){
        this.isError= true;
        return false;
      }
      this.isError= false;
      return true;
    },
    sendHotInLine(params) {
      var channel = null;

      if(sessionStorage.getItem('channel')!=null){
        channel  = sessionStorage.getItem('channel');
      }

      console.info('----getChannel---',encodeURIComponent(channel));

      var bdUrl = decodeURIComponent(window.location.href);
      // 进电信息预留
      // var sendParams = encodeURI(encodeURI(`phone=${params.phone || ''}&type=${params.type || ''}&estateId=${params.estateId || ''}&estateName=${params.estateName || ''}&column=${params.column || ''}&projectPkId=${params.projectPkId || ''}&channel=${channel || ''}`))+`&bdUrl=${bdUrl || ''}`;
      this.params.channel = decodeURIComponent(channel);
      this.params.bdUrl = decodeURIComponent(window.location.href); //获取当前页面地址

      this.$http.post(window.location.origin+ `/api/sendSms/consultationHotline`,this.params).then((response)=>{
        if(response.data.result){
          this.number='';
        }else{
          this.$emit('setIsFind', response.data.msg);
          this.isError= true;
          this.errorMsg = response.data.msg;
        }
      }).catch((response)=>{
        console.log(response);
        this.isError= true;
        this.errorMsg = response.data.msg;
      })
    },
    sendFromInLine() {
      var params = this.params;
      var channel = null;

      if(sessionStorage.getItem('channel')!=null){
          channel  = sessionStorage.getItem('channel');
      }

       params.channel = decodeURIComponent(channel);
       params.bdUrl = decodeURIComponent(window.location.href); //获取当前页面地址

       meteor.track('form', {convert_id: 1645519955454987 });
       this.$http.post(window.location.origin+`/api/sendSms/getFromInLine`,params).then((response)=>{
        if(response.data.result){
            this.show = true;
            this.isOK = true;
            this.number='';
            this.track(channel);
          }else{
            if(!this.isRecom){
              this.$emit('setError', response.data.msg);
            }
            this.isError= true;
            this.errorMsg = response.data.msg;
          }
        }).catch((response)=>{
           this.isError= true;
           this.errorMsg = response.data.msg;
      })
    },
    track:function(channel){
      //只有渠道中包含 jrtt-xxl 才让今日头条转换
      if(channel!=null && channel!='' && channel.search('jrtt-xxl')!=-1){
        meteor.track('form', {convert_id: 1648632590114830 });
        meteor.track('form', {convert_id: 1650880939862045 });
        meteor.track('form', {convert_id: 1650881186119815 });
        meteor.track("form", {convert_id: 1668533939538955});
        meteor.track("form", {convert_id: 1668477283548171});
        meteor.track("form", {convert_id: 1668547587417095});
        meteor.track("form", {convert_id: 1682396665182222});
        meteor.track("form", {convert_id: 1682398912359432});
        meteor.track("form", {convert_id: 1682319257532428});
        meteor.track("form", {convert_id: 1682399222688775});
      }
      if(channel!=null && channel!='' && channel.search('jrtt-xxl')!=-1 && window.location.href.indexOf('qqbdc')!=-1){
        meteor.track("form", {convert_id: "1669105619870728"})
      }
      if(channel!=null && channel!='' && channel.search('jrtt-xxl')!=-1 && window.location.href.indexOf('cqsuxu')!=-1){
        meteor.track("form", {convert_id: "1669105619870728"})
      }
      if(channel!=null && channel!='' && channel.search('baidu-xxl')!=-1){
        // window._agl && window._agl.push(['track', ['success', {t: 3}]]);
      }
      if(channel!=null && channel!='' && channel.search('ks-xxl')!=-1  && window.location.href.indexOf('qqbdc')!=-1){
        _ks_trace.push({event: 'form', convertId: 431428, cb: function(){    console.log('Your callback function here!')}});
      }
      if(channel!=null && channel!='' && channel.search('ks-xxl')!=-1  && window.location.href.indexOf('cqsuxu')!=-1){
        _ks_trace.push({event: 'form', convertId: 431428, cb: function(){    console.log('Your callback function here!')}});
      }
      if(channel!=null && channel!='' && channel.search('ks-xxl')!=-1  && window.location.href.indexOf('mtxfang')!=-1){
        _ks_trace.push({event: 'form', convertId: 431430, cb: function(){    console.log('Your callback function here!')}});
      }
      if(channel!=null && channel!='' && channel.search('ks-xxl')!=-1  && window.location.href.indexOf('hbaichi')!=-1){
        _ks_trace.push({event: 'form', convertId: 431430, cb: function(){    console.log('Your callback function here!')}});
      }
    },
    changeSelect(id){
      var list = this.estateItem.find((item)=>{
        return item.estateId === id;
      })
      var name =list.estateName;
      this.params.estateId= id;
      this.params.estateName= name;
    },
    setParams(index,eid,ename,column,proid,remark,phone,customerName){
      if (index == 40) {
        let strArr = column.split('&&');
        column = strArr[0];
        let address = strArr[1];
        let estate400 = strArr[2];
        this.params.estateAddress = address;
        this.params.estate400 = estate400;
      }

      //组装表单需要的参数
      this.params.type = this.leaveTelItems[index].inType;
      this.params.estateId = eid;
      this.params.estateName = ename;
      this.params.column = column;
      if(remark){
        this.params.remark = remark;
      }
      if(phone){
        this.params.phone = phone;
      }
      if(proid){
        this.params.projectPkId = proid;
      }
      if(customerName){
        this.params.customerName = customerName;
      }
    },
    leaveClick:function(index,eid,ename,column,proid,boo,codeInputShow){
      if(codeInputShow){
         this.codeInputShow = codeInputShow
      }

      this.leaveIndex = index;
      if(boo){
        this.isRecom=true;
        this.sevalue=ename;
      }else{
        this.show = true;
      }
      this.isOK = false;
      this.isError= false;
      if(column=='户型'){
        index = 15;
      }

      this.setParams(index,eid,ename,column,proid)
    },
    leaveCallClick:function(phone,eid,ename,column,proid,index,remark){

      this.$http.get('/api/index/getIsShowCallCode').then((response)=>{
        if(response.data.result){
          this.callImgCode = response.data.result;
        }

        this.calldata.phone=phone;
        this.calldata.eid=eid;
        this.calldata.ename=ename;
        this.calldata.column=column;
        this.calldata.proid=proid;
        this.calldata.index=index;
        this.calldata.remark=remark;

        if (this.callImgCode == "1" && !this.imgCodeSuccess) {
          this.svtext='';
          this.showSV=true;
        } else {
          this.lastLeaveCallClick();
        }

      }).catch((response)=>{
        console.log(response)
      })
    },
    lastLeaveCallClick:function(){
      var d = this.calldata;
      this.params.phone = d.phone;
      if(d.index){
        this.setParams(d.index,d.eid,d.ename,d.column,d.proid,d.remark)
      }else{
        this.setParams(14,d.eid,d.ename,d.column,d.proid,d.remark)
      }
      this.sendHotInLine(this.params);
      var newPhone = this.checkTel(d.phone);
      this.calldata.phone='';
      this.calldata.eid='';
      this.calldata.ename='';
      this.calldata.column='';
      this.calldata.proid='';
      this.calldata.index='';
      this.calldata.remark='';
      return  window.location.href =  'tel:'+newPhone;
    },
    checkTel:function(phone){ //打电话之前判断当前手机型号和浏览器
      let ua = navigator.userAgent.toLowerCase();
      let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
      if(isAndroid){
        if((ua.indexOf("ucbrowser") != -1 || ua.indexOf("honor") != -1) && phone.search(",,") > -1){  //UC浏览器时将两个逗号改为一个逗号
          phone = phone.replace(',,',',');
        }
      }
      return phone;
    },
    serOkClick(){
      if(this.username==null||this.username==""){
        this.$refs.inputName.focus();
        this.isError =true;
        this.errorMsg = '请输入您的姓名';
        return false;
      }
      if(this.number==null||this.number==""){
        this.$refs.inputTel.focus();
        this.isError =true;
        this.errorMsg = '请输入手机号码！';
        return false;
      }
      if(!this.checkPhone(this.number)){
        this.errorMsg = '请输入正确手机号码！';
        return false;
      }
      if(this.isCheck!=true){
        this.isError =true;
        this.errorMsg = '请阅读并勾选用户协议!';
        return false;
      }
      this.setParams(31,this.estate[1],this.estate[2],this.estate[3],null,null,this.number,this.username);
      if(this.codeInputShow==1 && this.pathType){
        return this.chekSmsCode(2);
      }else{
        this.sendFromInLine();
        this.isService=false;
      }
      this.isError= false;
    }
  }
}
</script>

<style scoped>
.b-service{position:fixed;left:0;right:0;bottom:0;z-index:8;height:50px;box-shadow:0 -3px 15px 0 rgba(0, 0, 0, 0.1);background:#fff;text-align:center;line-height:50px;}
.bs-time{float:left;width:40%;color:#b6b5b2;}
.bs-tell{float:left;width:60%;background:linear-gradient(90deg, #ff4d30 0%,#ff845e 100%);
  color:#fff;}
.edp{padding:9px 15px;height:42px;line-height:42px;}
.bs-online{float:left;width:18%;position:relative;padding-top:18px;line-height:24px;height:24px;overflow:hidden;}
.b-service .m-icon{width:20px;height:20px;vertical-align:top;margin-top:15px;margin-right:6px;}
.bs-online .m-icon{height:16px;position:absolute;margin:0;top:2px;left:50%;margin-left:-10px;}
.bs-time .m-icon{background-position:-201px 0;}
.bs-tell .m-icon{background-position:-201px -21px;}
.edp .bs-time,.edp .bs-tell{width:37%;border-radius:5px;margin-left:4%;}
.edp .bs-time .m-icon,.edp .bs-tell .m-icon{margin-top:11px;}

.leavewrap,.codewrap,.svwrap{background:rgba(0,0,0,0.8);position:fixed;top:0;left:0;right:0;bottom:0;z-index:19;}
.svwrap{display:flex;justify-content:center;align-items:center;text-align:center;background:rgba(0,0,0,0.5);}
.leavebox{position:absolute;left:50%;width:320px;margin-left:-160px;padding-bottom:25px;top:50%;margin-top:-150px;border-radius:2px;overflow:hidden;color:#2e303a;background:#fff;}
.title{font-size:16px;font-weight:700;padding:25px 25px 0;color:#ff4d30;line-height:30px;}
.stitle{font-size:12px;line-height:20px;padding:0 25px 5px;color:#aaa;}
.telinput{border:1px solid #e7e7e7;border-radius:2px;background:#f9f9f9;padding:11px 15px 10px;margin-left:25px;margin-right:25px;margin-top:10px;position:relative;}
.telinput input{display:block;width:70%;background:none;line-height:21px;height:21px;font-size:14px;}
.okbtn{line-height:43px;background:linear-gradient(90deg, #ff4d30 0%,#ff845e 100%);;color:#fff;border-radius:2px;text-align:center;font-size:15px;margin:15px 25px 0;cursor:pointer;}
.success{text-align:center;font-size:16px;font-weight:700;padding-top:25px;padding-bottom:5px;}
.success .m-icon{width:37px;height:37px;background-position:-37px -79px;display:block;margin:0 auto 8px;}
.recomInput{border:1px solid #e1e1e1;border-radius:2px;padding:2px 0 1px;margin-left:25px;margin-right:25px;margin-top:10px;padding-left:80px;position:relative;}
.recomInput span{position:absolute;left:10px;top:12px;}
.recomInput input{height:20px;line-height:20px;font-size:14px;padding:10px 0;width:100%;}
.error{font-size:12px;padding:5px 25px;color:#f44336;}
.recomInput+.error{text-align:center;}
.recomInput >>> .el-select{display:block;}
.recomInput >>> .el-input__inner{border:0;padding-left:0;color:#333;font-size:14px;}
.recomInput .code,.telinput .code{position:absolute;right:11px;top:12px;font-size:13px;color:#f44336;}
.recomInput .code.wait,.telinput .code.wait{color:#aaa;top:14px;}
.telinput .code{right:15px;}
.telinput .code.wait{right:17px;}

.bs-tell1{width:50%;float:left;background:#4a90e2;color:#fff;}
.bs-getprice{width:50%;float:right;background:#ff4c4c;color:#fff;}
.bs-ks{background:#2a2d4e;color:#fff;display:block;}

.codebox{position:absolute;left:50%;width:270px;margin-left:-160px;top:50%;margin-top:-150px;background:#fff;border-radius:5px;padding:25px;}
.codebox .ctitle{text-align:center;font-size:17px;line-height:24px;}
.codebox .ctitle small{font-size:12px;display:block;margin-top:5px;color:#999;}
.codebox .codeinput{border-bottom:1px solid #efefef;padding:10px 0;margin-top:10px;}
.codebox .input{width:65%;display:inline-block;}
.codebox .codebtn{float:right;color:#4E91FF;}
.codebox .wait{color:#bbb;}
.codebox .codesubmit{line-height:40px;text-align:center;background:#4E91FF;color:#fff;border-radius:2px;margin-top:25px;}
.codebox .error{padding-left:0;}

.servicewrap{position:fixed;left:0;right:0;top:0;bottom:0;background:rgba(0,0,0,.6);z-index:9;}
.servicewrap .whitewrap{padding:20px;border-radius:10px 10px 0 0;position:absolute;left:0;right:0;bottom:0;background:#fff;}
.servicewrap .svtitle{color:#333;font-size:22px;margin-bottom:17px;}
.servicewrap .svtitle span{font-size:12px;color:#999;display:block;font-weight:400;margin-top:8px;}
.servicewrap .svtitle b{font-weight:400;color:#F35656;}
.servicewrap .svtitle small{font-size:12px;color:#666;line-height:18px;margin-top:8px;display:block;}
.servicewrap .tellbox{background:#f1f1f1;border-radius:45px;padding:11px 18px;border-bottom:0;position:relative;}
.servicewrap .tellbox input{font-size:14px;line-height:20px;height:20px;background:none;}
.servicewrap .tellbox+.tellbox{margin-top:17px;}
.servicewrap .tellbox .codebtn{right:18px;top:11px;position:absolute;color:#E25E4A ;}
.servicewrap .tellbox .wait{color:#aaa;}
.servicewrap .okbtn{display:block;text-align:center;font-size:17px;margin:17px 0 0;background:linear-gradient(270deg, #E25E4A 0%, #FE8D46 100%);line-height:44px;border-radius:22px;color:#fff;}
.servicewrap .error{padding-left:18px;}
.xybox{position:fixed;left:0;right:0;top:0;bottom:0;z-index:20;background:#fff;line-height:21px;font-size:12px;padding:20px;overflow:auto;}
.xybox p{margin-top:8px;}
.xybox h3{line-height:30px;text-align:center;}
.leavebox .xy{padding-left:25px;text-align:left}
.closexy{position:absolute;right:15px;top:10px;color:#06f;font-size:14px;cursor:pointer}

/*.better{display:none;}*/
.better .leavebox{border-radius:15px;text-align:center;color:#333;margin-top:-230px;padding-bottom:15px}
#app .better .title{font-size:24px;font-weight:700;line-height:32px;padding-bottom:170px;background:url(../../assets/images/local-icon.png) center bottom no-repeat;background-size:auto 153px;padding-top:20px;margin-bottom:15px}
.better .stitle{font-size:13px}
.better .stitle span{color:#DC1A1A;}
.better .telinput{margin-top:20px;background:#f8f8f8;border:0;}
.better .telinput,.better .okbtn{border-radius:22px;margin-left:20px;margin-right:20px;}
.better .xy{color:#999;}
.better .xy a{color:#666;}
.better .xy .checkbox{background-image:url(../../assets/images/_check-icon.png);}
.better .error{text-align:left;padding-left:35px}
</style>



// WEBPACK FOOTER //
// src/components/public/LeaveTel.vue